import { OrderDataFusionSummary } from "../OrderDataFusionSummary";
import { StopProgress } from "../StopProgress";
import { CityState, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderOverview extends Layout {
    billingDistanceDangerImage: Image;
    citystateCustomer: CityState;
    horizontalspacer1: HorizontalSpacer;
    label4: Label;
    labelAddress1: Label;
    labelAddress2: Label;
    labelBillDistanceUm: Label;
    labelBillingDistance: Label;
    labelBillingDistanceCaption: Label;
    labelContactEmail: Label;
    labelContactPhone: Label;
    labelEquipmentTypeId: Label;
    labelOrderValueCaption: Label;
    labelReferenceNumbers: Label;
    labelTempDelim: Label;
    labelTempMax: Label;
    labelTempMin: Label;
    labelTemperatureRange: Label;
    labelTrackingRequired: Label;
    labelTrailerType: Label;
    labelWeightCaption: Label;
    layoutOrderDataFusionSummary: OrderDataFusionSummary;
    layoutStopProgress: StopProgress;
    panel15: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panel5: Panel;
    panel6: Panel;
    panel8: Panel;
    panelBillingDistance: Panel;
    panelCommodity: Panel;
    panelDataFusion: Panel;
    panelDelivered: Panel;
    panelOrderInfo: Panel;
    panelOrderValue: Panel;
    panelRefNbrs: Panel;
    panelStopInfo: Panel;
    panelTempRange: Panel;
    panelWeight: Panel;
    sourceCalculateOverridePay: DataSource;
    sourceCustomer: DataSource;
    sourceDataFusionOrderSummary: DataSource;
    sourceDistanceAlert: DataSource;
    sourceOrders: DataSource;
    textboxBillingDate: Textbox;
    textboxBillingUser: Textbox;
    textboxBolDate: Textbox;
    textboxCommodity: Textbox;
    textboxContactName: Textbox;
    textboxInvoiceNbr: Textbox;
    textboxInvoiceRecvDate: Textbox;
    textboxMargin: Textbox;
    textboxName: Textbox;
    textboxOrderValue: Textbox;
    textboxSalespersonId: Textbox;
    textboxTotalCharge: Textbox;
    textboxTotalPay: Textbox;
    textboxTransferDate: Textbox;
    textboxWeight: Textbox;
}
